<mat-card style="padding:10px" [ngClass]="{'filter-chip-box__mat-card-mobile-view': isMobile}">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    @if (!isMobile) {
      <div class="filter-chip-box__customer-text" data-testid="meet-filter-header-text">
        <b>{{totalCustomers}}</b> customers available from <b>{{filterCount}}</b> applied filters
      </div>
    }
    @if (isMobile) {
      <div class="filter-chip-box__customer-text">
        <b>{{filterCount}}</b> filters applied
      </div>
    }
    @if (!savedGroupBeingEdited) {
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button type="button" class="filter-chip-box__button filter-chip-box__clickable-text" data-testid="clear-filters-button" (click)="clearFilters.emit()">Clear Filters</button>
        @if (displaySavedGroupActions && !isMobile) {
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <button type="button" class="filter-chip-box__button" fxLayout="row" fxLayoutAlign="start center"
              data-testid="save-group-button"
              [disabled]="selectedSavedGroups.length > 0"
              (click)="savedGroup()">
              <i aria-hidden="true" [ngClass]="selectedSavedGroups.length == 0 ? 'material-icons filter-chip-box__icon' : 'material-icons filter-chip-box__disable-icon'">favorite_border</i>
              <span [ngClass]="selectedSavedGroups.length == 0 ? 'filter-chip-box__clickable-text' : 'filter-chip-box__disable-text'">Save This Group</span>
            </button>
            @if (selectedSavedGroups.length > 0) {
              <help-text class="filter-chip-box__help-text" [helpText]="infoHelpText" [displayOnLeft]="true"></help-text>
            }
          </div>
        }
      </div>
    }
    @if (savedGroupBeingEdited) {
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button type="button" class="filter-chip-box__button" fxLayout="row" fxLayoutAlign="space-between center"
          data-testid="rename-group-button"
          (click)="renameSavedGroup.emit()">
          <img alt="" class="filter-chip-box__edit-icon" src="{{editIconUrl}}">
          <span class="filter-chip-box__clickable-text">Rename This Group</span>
        </button>
        <button type="button" class="filter-chip-box__button" fxLayout="row" fxLayoutAlign="space-between center"
          data-testid="delete-group-button"
          (click)="deleteSavedGroup.emit(savedGroupBeingEdited)">
          <img alt="" class="filter-chip-box__delete-icon" src="{{deleteIconUrl}}">
          <span class="filter-chip-box__clickable-text">Delete This Group</span>
        </button>
      </div>
    }
  </div>
  <div [fxLayout]="getFlexLayout(isMobile)" fxLayoutAlign="space-between start">
    <div fxFlex="50" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="50">
      @if (filters.length > 0 || selectedSavedGroups.length > 0) {
        <div class="filter-chip-box__plain-text">Show me customers who...</div>
      }
      @if (filters.length > 0 || selectedSavedGroups.length > 0) {
        <div>
          <mat-chip-set>
            @for (filter of filters; track filter.id || filter.filterName || filter.name || $index) {
              <filter-chip
                class="filter-chip-box__filter-chip"
                [title]="filter.name"
                [ngClass]="{'filter-chip-box__filter-chip-mobile': isMobile}"
                [isMobile]="isMobile"
                (removeClicked)="filterRemoved.emit(filter)">
              </filter-chip>
            }
            @for (selectedSavedGroup of selectedSavedGroups; track selectedSavedGroup.id || selectedSavedGroup.name || $index) {
              <filter-chip
                class="filter-chip-box__filter-chip"
                [title]="selectedSavedGroup.formattedName"
                [isShowGroup]="true"
                [ngClass]="{'filter-chip-box__filter-chip-mobile': isMobile}"
                [isMobile]="isMobile"
                (removeClicked)="savedGroupFilterRemoved.emit(selectedSavedGroup)"
                (showGroupClicked)="showGroupClicked.emit(selectedSavedGroup)">
              </filter-chip>
            }
          </mat-chip-set>
        </div>
      }
    </div>
    <div fxLayout="column" fxFlex="50" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="50">
      @if (includeCustomerFilter.length > 0) {
        <div class="filter-chip-box__plain-text">And Includes:</div>
      }
      @if (includeCustomerFilter.length > 0) {
        <div>
          <mat-chip-list>
            @for (customer of includeCustomerFilter | slice : 0 : maxIndividualCustomer; track customer.id || customer.customerUid || customer.fullName || $index) {
              <filter-chip
                [title]="getCustomerDisplayName(customer)"
                [isMobile]="isMobile"
                (removeClicked)="includeCustomerFilterRemoved.emit(customer)">
              </filter-chip>
            }
          </mat-chip-list>
          @if (includeCustomerFilter.length > maxIndividualCustomer) {
            <button
              type="button"
              class="filter-chip-box__button filter-chip-box__clickable-text"
              (click)="moreIncludedCustomersClicked()">
              Show Additional Customers
            </button>
          }
        </div>
      }
      @if (excludeCustomerFilter.length > 0) {
        <div class="filter-chip-box__plain-text">And Excludes:</div>
      }
      @if (excludeCustomerFilter.length > 0) {
        <div>
          <mat-chip-list>
            @for (customer of excludeCustomerFilter | slice : 0 : maxIndividualCustomer; track customer.id || customer.customerUid || customer.fullName || $index) {
              <filter-chip
                [title]="getCustomerDisplayName(customer)"
                [isMobile]="isMobile"
                (removeClicked)="excludeCustomerFilterRemoved.emit(customer)">
              </filter-chip>
            }
          </mat-chip-list>
          @if (excludeCustomerFilter.length > maxIndividualCustomer) {
            <button
              type="button"
              class="filter-chip-box__button filter-chip-box__clickable-text"
              (click)="moreExcludedCustomersClicked()">
              +{{excludeCustomerFilter.length - maxIndividualCustomer}} more
            </button>
          }
        </div>
      }
    </div>
  </div>
</mat-card>
